export default __webpack_public_path__ + "static/media/tarrot-card-love.14c6f4e4.jpg";